/**
 * Translucent atmospheric layer using the uploaded void-city image.
 * Use inside a position: relative parent. Sits behind content, never blocks it.
 *
 * Variants:
 *   intensity = "subtle"   → faint mood (sections)
 *   intensity = "hero"     → stronger, hero blocks
 *   intensity = "footer"   → soft fade at the bottom
 */
export default function VoidAtmosphere({ intensity = "subtle", className = "" }) {
  const opacity =
    intensity === "hero" ? 0.22 : intensity === "footer" ? 0.12 : 0.14;

  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {/* Image layer */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('/brand/void-city.png')",
          backgroundSize: "cover",
          backgroundPosition: "center 18%",
          opacity,
          filter: "saturate(0.5) hue-rotate(-15deg)",
          WebkitMaskImage:
            "linear-gradient(180deg, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.7) 55%, rgba(0,0,0,0) 100%)",
          maskImage:
            "linear-gradient(180deg, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.7) 55%, rgba(0,0,0,0) 100%)",
        }}
      />
      {/* Purple-black gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(900px 500px at 50% 10%, rgba(157,76,221,0.28), transparent 60%), linear-gradient(180deg, rgba(15,0,30,0.55) 0%, rgba(5,0,15,0.95) 100%)",
        }}
      />
      {/* Hot pink accent glow */}
      <div className="absolute -top-32 left-1/4 w-[500px] h-[500px] rounded-full bg-[#ff1493] opacity-[0.10] blur-[120px]" />
      <div className="absolute -bottom-40 right-1/4 w-[600px] h-[600px] rounded-full bg-[#9d4cdd] opacity-[0.18] blur-[140px]" />
    </div>
  );
}
